import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../pages/Auth/slice";
import { useNavigate, useLocation } from "react-router-dom";

export default function AuthGate() {
  const { token } = useSelector(selectAuth);
  const nav = useNavigate();
  const { pathname } = useLocation();

  // 현재 경로가 /cn 계열이면 CN 모드
  const base = pathname.startsWith("/cn") ? "/cn" : "";

  useEffect(() => {
    const stored = (typeof localStorage !== "undefined" && localStorage.getItem("token")) || "";
    if (token || stored) {
      nav(`${base}/profiling`, { replace: true });
    } else {
      nav(`${base}/login`, { replace: true });
    }
  }, [token, base, nav]);

  return null;
}